import React from "react";
import { Route, Routes } from "react-router-dom";

import Rewards from "./Pages/Rewards/Rewards";
import Invoice from "./Pages/Invoice/Invoice";
import Wallets from "./Pages/Wallets/Wallets";
import Profile from "./Pages/Profile/Profile";
import Guides from "./Pages/Guides/Guides";

export default function Dashboard() {
  return (
    <>
      <Routes>
        <Route path="/invoice" index element={<Invoice />} />
        <Route path="/rewards" element={<Rewards />} />
        <Route path="/wallets" element={<Wallets />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/guides" element={<Guides />} />
      </Routes>
    </>
  );
}
